(function () {
  'use strict';

  var audio = new Audio();
  var playlist = [];
  var currentIndex = -1;

  function $(sel) { return document.querySelector(sel); }

  function formatTime(s) {
    if (isNaN(s)) return '0:00';
    return Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');
  }

  function updatePlayIcon(playing) {
    var play = $('.icon-play');
    var pause = $('.icon-pause');
    if (play) play.style.display = playing ? 'none' : 'block';
    if (pause) pause.style.display = playing ? 'block' : 'none';
  }

  function showPlayer() {
    var el = $('[data-audio-player]');
    if (el) el.style.display = '';
  }

  function loadTrack(track) {
    audio.src = track.previewUrl;
    audio.load();

    var artwork = $('[data-player-artwork]');
    if (artwork) { artwork.src = track.artwork || ''; artwork.alt = track.title || ''; }

    var title = $('[data-player-title]');
    if (title) title.textContent = track.title || '\u2014';

    var meta = $('[data-player-meta]');
    if (meta) {
      var parts = [];
      if (track.bpm) parts.push(track.bpm + ' BPM');
      meta.textContent = parts.join(' \u00b7 ');
    }

    showPlayer();
  }

  function play() { audio.play().catch(function() {}); }
  function pause() { audio.pause(); }

  function playTrack(index) {
    if (index < 0 || index >= playlist.length) return;
    currentIndex = index;
    loadTrack(playlist[currentIndex]);
    play();
    highlightRow();
  }

  function highlightRow() {
    document.querySelectorAll('[data-beat-row]').forEach(function(row) {
      row.classList.toggle('is-playing', row.dataset.previewUrl === audio.src);
    });
  }

  function buildPlaylist() {
    var rows = document.querySelectorAll('[data-beat-row]');
    playlist = Array.from(rows).map(function(row) {
      return {
        title: row.dataset.title,
        bpm: row.dataset.bpm,
        key: row.dataset.key,
        genre: row.dataset.genre,
        previewUrl: row.dataset.previewUrl,
        artwork: row.dataset.artwork,
      };
    });
  }

  function handlePlayBeat(data) {
    buildPlaylist();
    currentIndex = playlist.findIndex(function(t) { return t.previewUrl === data.previewUrl; });

    if (audio.src === data.previewUrl && !audio.paused) {
      pause();
      return;
    }

    loadTrack(data);
    play();
  }

  // Beat row click -> play
  document.addEventListener('click', function(e) {
    var playBtn = e.target.closest('.beat-row__play');
    if (playBtn) {
      var row = playBtn.closest('[data-beat-row]');
      if (row) handlePlayBeat(row.dataset);
      return;
    }

    var toggleBtn = e.target.closest('[data-player-toggle]');
    if (toggleBtn) { audio.paused ? play() : pause(); return; }

    var prevBtn = e.target.closest('[data-player-prev]');
    if (prevBtn && currentIndex > 0) { playTrack(currentIndex - 1); return; }

    var nextBtn = e.target.closest('[data-player-next]');
    if (nextBtn && currentIndex < playlist.length - 1) { playTrack(currentIndex + 1); return; }
  });

  // External play-beat event (from product page, etc.)
  document.addEventListener('play-beat', function(e) { handlePlayBeat(e.detail); });

  // Audio events
  audio.addEventListener('timeupdate', function() {
    var seek = $('[data-player-seek]');
    var cur = $('[data-player-current]');
    if (seek && audio.duration) seek.value = (audio.currentTime / audio.duration) * 100;
    if (cur) cur.textContent = formatTime(audio.currentTime);
  });

  audio.addEventListener('loadedmetadata', function() {
    var dur = $('[data-player-duration]');
    if (dur) dur.textContent = formatTime(audio.duration);
  });

  audio.addEventListener('play', function() { updatePlayIcon(true); highlightRow(); });
  audio.addEventListener('pause', function() { updatePlayIcon(false); highlightRow(); });
  audio.addEventListener('ended', function() {
    if (currentIndex < playlist.length - 1) playTrack(currentIndex + 1);
    else updatePlayIcon(false);
  });

  // Seek + volume
  document.addEventListener('input', function(e) {
    if (e.target.matches('[data-player-seek]') && audio.duration) {
      audio.currentTime = (e.target.value / 100) * audio.duration;
    }
    if (e.target.matches('[data-player-volume]')) {
      audio.volume = parseFloat(e.target.value);
    }
  });

  // Persist volume
  var savedVolume = localStorage.getItem('tb-volume');
  if (savedVolume !== null) audio.volume = parseFloat(savedVolume);

  audio.addEventListener('volumechange', function() {
    localStorage.setItem('tb-volume', audio.volume);
    var vol = $('[data-player-volume]');
    if (vol) vol.value = audio.volume;
  });
})();
